import { z } from 'zod'

export const RpStandSchema = z.object({
  name: z.string().min(1, { message: 'Имя обязательно' }),
  stream: z.string(),
})

export type TRpStandFormData = z.infer<typeof RpStandSchema>
